import React, { useState } from 'react';
import { FaTimes, FaCar, FaExclamationCircle } from 'react-icons/fa';

function TrafficConditionSelector({ isOpen, onClose, onApply }) {
    const [selectedConditions, setSelectedConditions] = useState([]);
    const [severity, setSeverity] = useState(0);
  
    const conditions = [
      { id: 'high_congestion', label: 'High Congestion' },
      { id: 'accidents', label: 'Accidents' },
      { id: 'low_congestion', label: 'Low Congestion' },
      { id: 'road_closures', label: 'Road Closures' },
      { id: 'construction', label: 'Construction' }
    ];
  
    const handleConditionToggle = (conditionId) => {
      setSelectedConditions(prev => {
        if (prev.includes(conditionId)) {
          return prev.filter(id => id !== conditionId);
        } else {
          return [...prev, conditionId];
        }
      });
    };
  
    if (!isOpen) return null;
  
    return (
      <div className="traffic-condition-overlay">
        <div className="traffic-condition-modal">
          <div className="traffic-condition-header">
            <h3>Select Traffic Conditions</h3>
            <button className="close-button" onClick={onClose}>
              <FaTimes />
            </button>
          </div>
          
          <div className="traffic-condition-content">
            <div className="condition-section">
              <div className="section-icon-title">
                <FaCar className="condition-icon" />
                <span>Traffic Conditions</span>
              </div>
              
              <div className="conditions-grid">
                {conditions.map(condition => (
                  <label key={condition.id} className="condition-option">
                    <input
                      type="checkbox"
                      checked={selectedConditions.includes(condition.id)}
                      onChange={() => handleConditionToggle(condition.id)}
                    />
                    <span>{condition.label}</span>
                  </label>
                ))}
              </div>
            </div>
  
            <div className="severity-section">
              <div className="section-icon-title">
                <FaExclamationCircle className="condition-icon" />
                <span>Severity</span>
              </div>
              
              <div className="severity-slider">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={severity}
                  onChange={(e) => setSeverity(e.target.value)}
                  className="slider"
                />
              </div>
            </div>
          </div>
  
          <div className="traffic-condition-footer">
            <button className="cancel-link" onClick={onClose}>Cancel</button>
            <button 
              className="apply-button" 
              onClick={() => {
                onApply({ conditions: selectedConditions, severity });
                onClose();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    );
  }

export default TrafficConditionSelector; 